import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
    return (
        <a
            href="https://wa.me/919918000070?text=Hi%20Exportfy%2C%20I%27d%20like%20to%20discuss%20an%20export%20requirement."
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-float"
            className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BA5A] shadow-2xl shadow-emerald-900/30 flex items-center justify-center text-white transition-transform hover:-translate-y-0.5"
        >
            <MessageCircle className="w-6 h-6" strokeWidth={1.75} />
        </a>
    );
}
